import { Modal, Input, Button, Select } from 'antd'
import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@ant-design/icons'
import { http } from '@services/http'
import SuccessModal from './SuccessModal'
import ErrorModal from './ErrorModal'
import {
	fetchUoMGroups,
	fetchItemsServicesGroups,
	fetchItemsModalServices,
} from '@utils/fetchData'
import { useQuery } from '@tanstack/react-query'

const CreteServicesItemModal = ({ visible, data, onClose }) => {
	const { t } = useTranslation()
	const successRef = useRef()
	const errorRef = useRef()

	const [loading, setLoading] = useState(false)
	const [itemName, setItemName] = useState('')
	const [unitMeasure, setUnitMeasure] = useState('')
	const [u_Number, setU_Number] = useState('')
	const [price, setPrice] = useState('')
	const [currency, setCurrency] = useState('')
	const [timer, setTimer] = useState('')
	const [serviceGroup, setServiceGroup] = useState('')
	const [modalService, setModalService] = useState('')

	const {
		data: uomData = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['uoMEntry'],
		queryFn: fetchUoMGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: servicesGroupData = [], isLoading: servicesLoading } =
		useQuery({
			queryKey: ['servicesGrp'],
			queryFn: fetchItemsServicesGroups,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})
	const { data: modalServiceData = [] } = useQuery({
		queryKey: ['modalService'],
		queryFn: fetchItemsModalServices,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const resetForm = () => {
		setItemName('')
		setUnitMeasure('')
		setU_Number('')
		setPrice('')
		setCurrency('')
		setTimer('')
		setLoading(false)
		setServiceGroup('')
		setModalService('')
	}

	const postData = async () => {
		setLoading(true)

		try {
			await http.post('api/items/add-item-admin', {
				itemName: itemName,
				itemType: 'L',
				itemsGroupCode: '101',
				uoMGroupEntry: unitMeasure,
				u_Number: String(u_Number),
				u_Timer: timer,
				price: price,
				currency,
				u_Modal: modalService,
				u_ServiceGroup: serviceGroup,
			})
			successRef.current.open(t('sucCreated'))
			onClose()
			resetForm()
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito  font-extrabold text-[#000000]">
					{t('addService')}
				</h1>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="70%"
			style={{ height: '70%' }}
			bodyStyle={{ height: 'calc(100% - 55px)', overflowY: 'auto' }}
		>
			<div className="w-full px-2 sm:px-14">
				<div className="flex flex-col items-end gap-10 sm:flex-row mt-5">
					<div className="flex flex-col gap-2  w-full">
						<p>{t('itemName')}</p>
						<Input
							value={itemName}
							type="text"
							onChange={(e) => {
								setItemName(e.target.value)
							}}
							className="flex h-10 min-w-[200px] w-full  items-center justify-center border-[1px] border-[#D0D0D0]"
						/>
					</div>
					<div className="flex flex-col gap-2  w-full">
						<p className="font-nunito">{t('currency')}</p>
						<Select
							value={currency}
							className="flex h-10  w-full min-w-[100px] items-center justify-center "
							style={{ color: 'black' }}
							onChange={(val) => {
								setCurrency(val)
							}}
							options={[
								{
									label: 'UZS',
									value: 'UZS',
								},
							]}
						/>
					</div>
					<div className="flex flex-col gap-2 w-full">
						<p className="font-nunito">{`${t('price')} `}</p>
						<Input
							type="number"
							onWheel={(e) => e.target.blur()}
							value={price}
							className="flex h-10 w-auto items-center justify-center"
							style={{ color: 'black' }}
							onChange={(e) => {
								setPrice(e.target.value)
							}}
						/>
					</div>
					<div className="flex flex-col  gap-3 w-full">
						<p className="font-nunito text-center">{`${t('timerItem')}`}</p>
						<Input
							value={timer}
							className="flex h-10 min-w-[100px] w-full  items-center justify-center"
							style={{ color: 'black' }}
							onChange={(e) => {
								setTimer(e.target.value)
							}}
						/>
					</div>
				</div>
				<div className="flex flex-col items-end gap-10 sm:flex-row mt-5">
					<div className=" flex flex-col gap-3 sm:mt-5 w-full">
						<p>{`${t('u_ServiceGroup')}`}</p>
						<Select
							type="text"
							value={serviceGroup}
							onChange={(val) => {
								setServiceGroup(val)
							}}
							className="flex h-10 w-full  items-center justify-center border-[#D0D0D0]"
							options={servicesGroupData.map((item) => ({
								label: item.fldValue,
								value: item.descr,
							}))}
						/>
					</div>
					<div className=" flex flex-col gap-3 sm:mt-5 w-full">
						<p>{`${t('u_ModalService')}`}</p>
						<Select
							type="text"
							value={modalService}
							onChange={(val) => {
								setModalService(val)
							}}
							className="flex h-10 w-full  items-center justify-center border-[#D0D0D0]"
							options={modalServiceData.map((item) => ({
								label: item.descr,
								value: item.fldValue,
							}))}
						/>
					</div>
					<div className=" flex flex-col gap-3 sm:mt-5 w-full">
						<p>{`${t('unitMsr')}`}</p>
						<Select
							type="text"
							value={unitMeasure}
							onChange={(val) => {
								setUnitMeasure(val)
							}}
							className="flex h-10 w-full  items-center justify-center border-[#D0D0D0]"
							options={uomData.map((item) => ({
								label: item.ugpName,
								value: item.ugpEntry,
							}))}
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-5 w-full">
						<p>{t('u_Number')}</p>
						<Input
							value={u_Number}
							type="number"
							onWheel={(e) => e.target.blur()}
							onChange={(e) => {
								setU_Number(e.target.value)
							}}
							className="flex h-10 w-full  items-center justify-center border-[1px] border-[#D0D0D0]"
						/>
					</div>
				</div>
				<div className="flex items-center gap-10 mt-14 justify-between">
					<Button
						onClick={() => {
							onClose()
						}}
						className="w-full bg-red-600 h-[35px] rounded-lg text-white"
					>
						{t('cancel')}
					</Button>
					<Button
						onClick={postData}
						loading={loading}
						disabled={loading}
						className="w-full bg-[#0A4D68] h-[35px] rounded-lg text-white"
					>
						{t('add')}
					</Button>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Modal>
	)
}

export default CreteServicesItemModal
